import { render, staticRenderFns } from "./SingleItemLayoutConstructor.vue?vue&type=template&id=c37e543c"
import script from "./SingleItemLayoutConstructor.vue?vue&type=script&lang=js"
export * from "./SingleItemLayoutConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c37e543c')) {
      api.createRecord('c37e543c', component.options)
    } else {
      api.reload('c37e543c', component.options)
    }
    module.hot.accept("./SingleItemLayoutConstructor.vue?vue&type=template&id=c37e543c", function () {
      api.rerender('c37e543c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/single-item-layout-constructor/SingleItemLayoutConstructor.vue"
export default component.exports